import dishData from './shared/state';

export default {
  modules: {
    dishData,
  },
};
